<!-- src/components/Toast.vue -->
<template>
    <div v-if="visible" class="toast" :class="type">
      {{ message }}
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        visible: false,
        message: '',
        type: 'info'
      };
    },
    methods: {
      showToast(message, type = 'info') {
        this.message = message;
        this.type = type;
        this.visible = true;
        
        setTimeout(() => {
          this.visible = false;
        }, 3000);
      }
    }
  };
  </script>
  
  <style>
  .toast {
    position: fixed;
    top: calc(50vh - 20px);
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 20px;
    color: #fff;
    background-color: #00000060;
    border-radius: 5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
  }
  .toast.success {
    background-color: #4caf50;
  }
  .toast.error {
    background-color: #f44336;
  }
  .toast.warning {
    background-color: #ff9800;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Toast.vue